export default "__VITE_ASSET__B7Ivv3jG__"